import * as React from "react";

import "./FriendbuyLogo.css";
import { onClickSendToMerchant } from "../../utils/sendClickToMerchant";
import { WidgetProps } from "../Widget/Widget";
import { getHorizontalAlignment } from "../../utils/getHorizontalAlignment";

export interface FriendbuyLogoProps extends WidgetProps {
  configName: string;
  style?: React.CSSProperties;
  content: string;
  merchantId: string;
}

export class FriendbuyLogo extends React.Component<FriendbuyLogoProps> {
  component: HTMLAnchorElement | null;

  componentDidMount() {
    if (this.component && this.props.horizontalAlign) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  componentDidUpdate(prevProps: FriendbuyLogoProps) {
    if (
      this.component &&
      prevProps.horizontalAlign !== this.props.horizontalAlign
    ) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  render() {
    const { configName, style, content, merchantId } = this.props;

    return (
      <a
        id={configName}
        onClick={onClickSendToMerchant(configName)}
        className="Friendbuy-logo"
        style={{ ...style }}
        aria-label="Friendbuy (opens in a new window)"
        href={`https://www.friendbuy.com?utm_source=referral_widget&utm_campaign=${merchantId}`}
        target="blank"
        tabIndex={0}
        ref={(component) => (this.component = component)}
        rel="noopener"
        role="link"
      >
        {content}
        <span className="screen-reader-only">Friendbuy.com</span>
      </a>
    );
  }
}
